import { render, staticRenderFns } from "./QbrPlan.vue?vue&type=template&id=7064aea8&scoped=true"
import script from "./QbrPlan.vue?vue&type=script&lang=js"
export * from "./QbrPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064aea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7064aea8')) {
      api.createRecord('7064aea8', component.options)
    } else {
      api.reload('7064aea8', component.options)
    }
    module.hot.accept("./QbrPlan.vue?vue&type=template&id=7064aea8&scoped=true", function () {
      api.rerender('7064aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QBR/QbrPlan.vue"
export default component.exports